package com.example.mystybag.core.logic.base

import com.example.mystybag.core.defines.UtilsActionsDefines.ACTION_NONE

class EmptyViewModel(
    context                         : AppContext,
    private val navigationVisible   : Boolean = true,
    private var navigationTitle     : String? = null
): ChildViewModel<Unit>(
    context         = context,
    uiData          = Unit,
    baseAction      = ACTION_NONE
) {
    override fun onCreate() {
        navControls.isVisible = navigationVisible
        navigationTitle?.also {
            navControls.title = it
        }
    }
}